module.exports = __webpack_public_path__ + "static/media/marker-map-focused.ebc40326.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Schools/assets/img/marker-map-focused.svg
// module id = 1384
// module chunks = 0